import ExternalLinkHandler from "./ExternalLinkHandler";

export default ExternalLinkHandler;
